export default __webpack_public_path__ + "static/media/gallery-wip-handle-neck_04.1ad7d4d7.jpg";